import CityPageTemplate from "../city-template/CityPageTemplate";
import { norfolkVaConfig } from "./data";

export default function NorfolkVaPage() {
  return <CityPageTemplate config={norfolkVaConfig} />;
}